class algoliaModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    const btn = this.querySelector('button[type="button"]');
    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    const headerSearch = document.querySelector("#headerSearch details");
    const headerSummary = document.querySelector("#headerSearch summary");
    event.target.closest("details").setAttribute("open", true);
    if (headerSearch) {
      headerSearch.setAttribute("open", true);;
    }
    document.body.classList.add("overflow-hidden");
    const modalOverlay = document.querySelector(".modal-overlay");
    const algoliaPanel = document.querySelector(".aa-PanelLayout");
    const algoliaPanelContainer = document.querySelector(".aa-Panel");
    if (algoliaPanel) algoliaPanel.classList.remove("hide");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (typeof removeTrapFocus === "function") {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
    const algoliaPanel = document.querySelector(".aa-PanelLayout");
    if (algoliaPanel) algoliaPanel.classList.add("hide");
  }
}

customElements.define("algolia-modal", algoliaModal);
